import { isEmpty, isEqual } from 'lodash';
import { useState, useCallback } from 'react';

const InvoiceItemsHook = () => {
  const [productsToInvoice, setProductsToInvoice] = useState(null);

  const getItemsToInvoice = (type, items) => {
    if (!isEmpty(items)) {
      let allProducts = productsToInvoice || {};
      const itemsToInvoice = items?.length ? items : null;

      if (type === 'PRODUCTS') {
        if (!isEqual(productsToInvoice?.products, itemsToInvoice)) {
          allProducts = { ...allProducts, products: itemsToInvoice };
          setProductsToInvoice(allProducts);
        }
      } else if (type === 'WORKLOGS') {
        if (!isEqual(productsToInvoice?.worklogs, itemsToInvoice)) {
          allProducts = { ...allProducts, worklogs: itemsToInvoice };
          setProductsToInvoice(allProducts);
        }
      }
    }
  };

  return {
    getItemsToInvoice,
    productsToInvoice
  };
};

export default InvoiceItemsHook;
